<template>
  <div class="footer-button-view" :class="isFixed ? 'fixed' : ''">
    <div class="footer-button-content px-15 flex">
      <slot name="default" v-if="$slots.default"></slot>
      <template v-else>
        <van-button
          v-if="showCancel"
          class="footer-item-btn"
          :class="type === 'three' ? 'three-btn' : 'flex-1'"
          type="primary"
          plain
          @click="handleCancel"
        >
          {{ cancelText }}
        </van-button>

        <van-button v-if="showOk" class="flex-1" type="primary" @click="handleSubmit" :disabled="okDisabled">
          {{ okText }}
        </van-button>
        <template v-if="type === 'three' && menuList.length">
          <van-popover
            v-model:show="showMenu"
            placement="top-end"
            :show-arrow="false"
            :actions="menuList"
            @select="handleMenu"
            class="xs-button-van-popover"
            :offset="[14, 10]"
          >
            <template #reference>
              <div
                class="flex items-center justify-center rounded-[4px] ml-[8px] flex-col w-[23px] border border-solid border-theme h-full"
              >
                <span
                  v-for="(item, index) in 3"
                  :key="index"
                  :class="item !== 3 ? 'mb-[4px]' : ''"
                  class="w-[4px] h-[4px] bg-theme rounded-full"
                ></span>
              </div>
            </template>
          </van-popover>
        </template>
      </template>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
defineProps({
  type: {
    default: "two" //根据组件默认两列平分，传 three 三列
  },
  showMore: {
    default: true //是否显示更多菜单,仅在type=== three中可用
  },
  menuList: {
    default: () => [] //更多菜单的列表，仅在type=== three中可用
  },
  showCancel: {
    default: true
  },
  showOk: {
    default: true
  },
  cancelText: {
    default: "取消"
  },
  okText: {
    default: "保存"
  },
  okDisabled: {
    default: false // OK按钮是否禁用
  },
  isFixed: {
    default: true //是否需要定位在底部
  }
});

const emit = defineEmits(["cancel", "submit", "menu"]);

const handleCancel = () => emit("cancel");

const handleSubmit = () => emit("submit");

const showMenu = ref(false);

const handleMenu = item => emit("menu", item.label);
</script>
<style lang="less" scoped>
.footer-button-view {
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 78px;
  border-top: 1px solid #ccd3df;
  .footer-button-content {
    padding-top: 10px;
  }
  .footer-item-btn {
    margin-right: 10px;
  }
  .three-btn {
    width: 120px;
  }
}
</style>
